// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2D74x","actions":"GroupTable_actions__3KslY","deleteModalFooter":"GroupTable_deleteModalFooter__1Xl7y"};